// Authentication service for OrderTrack Pro
import { api } from './api';

class AuthService {
  constructor() {
    this.currentUser = null;
    this.token = null;
    this.init();
  }

  init() {
    // Load stored authentication data
    const storedToken = localStorage.getItem('ordertrack_token');
    const storedUser = localStorage.getItem('ordertrack_user');
    
    if (storedToken && storedUser) {
      this.token = storedToken;
      try {
        this.currentUser = JSON.parse(storedUser);
      } catch (e) {
        console.error('Error parsing stored user data:', e);
        this.clearAuth();
      }
    }
  }

  async login(username, password) {
    try {
      // For demo purposes - simple auth check
      if ((username === 'admin' || username === 'manager' || username === 'operator') && password === 'password') {
        // Create mock user data
        const userData = {
          id: `user-${Date.now()}`,
          username: username,
          fullName: username === 'admin' ? 'Administrator' : username === 'manager' ? 'Manager User' : 'Operator User',
          email: `${username}@ordertrack.com`,
          role: username.charAt(0).toUpperCase() + username.slice(1),
          status: 'Active',
          createdDate: new Date().toISOString(),
          permissions: this.getPermissionsByRole(username)
        };

        // Create mock token
        const token = `token-${Date.now()}-${username}`;
        
        // Store authentication data
        this.token = token;
        this.currentUser = userData;
        
        localStorage.setItem('ordertrack_token', token);
        localStorage.setItem('ordertrack_user', JSON.stringify(userData));
        
        return {
          success: true,
          user: userData,
          token: token,
          message: 'Login successful'
        };
      } else {
        return {
          success: false,
          message: 'Invalid username or password'
        };
      }
    } catch (error) {
      console.error('Login error:', error);
      return {
        success: false,
        message: 'Login failed due to an error'
      };
    }
  }

  logout() {
    this.token = null;
    this.currentUser = null;
    localStorage.removeItem('ordertrack_token');
    localStorage.removeItem('ordertrack_user');
  }

  isAuthenticated() {
    return !!(this.token && this.currentUser);
  }

  getCurrentUser() {
    return this.currentUser;
  }

  getToken() {
    return this.token;
  }

  getPermissionsByRole(role) {
    const permissions = {
      admin: {
        orders: { create: true, read: true, update: true, delete: true },
        brandSpecs: { create: true, read: true, update: true, delete: true },
        dispatches: { create: true, read: true, update: true, delete: true },
        reports: { create: true, read: true, update: true, delete: true },
        users: { create: true, read: true, update: true, delete: true }
      },
      manager: {
        orders: { create: true, read: true, update: true, delete: false },
        brandSpecs: { create: true, read: true, update: true, delete: false },
        dispatches: { create: true, read: true, update: true, delete: false },
        reports: { create: true, read: true, update: false, delete: false },
        users: { create: false, read: true, update: false, delete: false }
      },
      operator: {
        orders: { create: false, read: true, update: false, delete: false },
        brandSpecs: { create: false, read: true, update: false, delete: false },
        dispatches: { create: true, read: true, update: false, delete: false },
        reports: { create: false, read: true, update: false, delete: false },
        users: { create: false, read: false, update: false, delete: false }
      }
    };
    
    return permissions[role] || permissions.operator;
  }

  hasPermission(resource, action) {
    if (!this.currentUser) return false;
    
    const userPermissions = this.currentUser.permissions;
    return userPermissions[resource] && userPermissions[resource][action];
  }

  clearAuth() {
    this.logout();
  }
}

// Create singleton instance
export const authService = new AuthService();
export default authService;